import { createRoutine } from 'redux-saga-routines';

export const getTrybeBalancesRoutine = createRoutine('trybe/GET_TRYBE_BALANCES');
export const stakeTrybeRoutine = createRoutine('trybe/STAKE_TRYBE');
export const unStakeTrybeRoutine = createRoutine('trybe/UNSTAKE_TRYBE');

export const claimTrybeRoutine = createRoutine('trybe/CLAIM_TRYBE');